import React from "react";

import PhoneIphoneIcon from "@material-ui/icons/PhoneIphone";
import TabletIcon from "@material-ui/icons/Tablet";
import DesktopMacIcon from "@material-ui/icons/DesktopMac";
import TvIcon from "@material-ui/icons/Tv";
import Tooltip from "@material-ui/core/Tooltip";
import Chip from "@material-ui/core/Chip";

const DeviceCell = (rowData) => {
  if (!rowData.context) return null;
  if (!rowData.context.ua_details || !rowData.context.ua_details.device) return null;
  let type = rowData.context.ua_details.device.type;
  let ua = rowData.context.ua_details;
  let icon = null;
  switch (type) {
    case 'smartphone':
      icon = <PhoneIphoneIcon />;
      break;
    case 'desktop':
      icon = <DesktopMacIcon />;
      break;
    case 'tablet':
      icon = <TabletIcon />;
      break;
    case 'television':
      icon = <TvIcon />;
      break;
  }
  return (
    <React.Fragment>
    <span className="p-column-title">Device</span>      
        <Tooltip title={`${type} ${ua.device.brand} ${ua.device.model}`}>
          <Chip
          icon={icon}
            label={ua.device.brand?`${ua.device.brand} ${ua.device.model}`:type}
            size="small"
            variant="outlined"
          />
        </Tooltip>
    </React.Fragment>
  );
};

export default DeviceCell;
